/* SY — comportamento das seções da SOYA PARIS (cronômetro, gavetas, país, carrosséis, cartões,
   compra rápida). Sem dependência: cada parte se liga ao que existir na página. */
(() => {
  'use strict';

  /* ---------------------------------------------------------------- cronômetro diário */
  const doisDigitos = (n) => String(n).padStart(2, '0');
  const cronometros = document.querySelectorAll('[data-sy-countdown]');
  if (cronometros.length) {
    // conta até a meia-noite de PARIS, para qualquer visitante: o app da referência recomeça todo dia no mesmo
    // instante (22:00 UTC no horário de verão), não na meia-noite de quem visita
    const paris = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' });
    const tique = () => {
      const p = {};
      paris.formatToParts(new Date()).forEach((x) => { p[x.type] = +x.value; });
      let resto = (86400 - (p.hour * 3600 + p.minute * 60 + p.second)) % 86400;
      const h = Math.floor(resto / 3600); resto -= h * 3600;
      const m = Math.floor(resto / 60); const s = resto - m * 60;
      cronometros.forEach((c) => {
        c.querySelector('[data-h]').textContent = doisDigitos(h);
        c.querySelector('[data-m]').textContent = doisDigitos(m);
        c.querySelector('[data-s]').textContent = doisDigitos(s);
      });
    };
    tique();
    setInterval(tique, 1000);
  }

  /* ---------------------------------------------------------------- gavetas (menu e compra rápida) */
  const travarRolagem = (sim) => { document.documentElement.style.overflow = sim ? 'hidden' : ''; };

  class SyDrawer extends HTMLElement {
    static estilo = '';
    constructor() {
      super();
      const raiz = this.attachShadow({ mode: 'open' });
      raiz.innerHTML = `<style>${this.constructor.estilo}</style>
        <button part="outside-close-button" aria-label="Fermer" data-fechar><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor" stroke-width="2"/></svg></button>
        <div part="overlay"></div><div part="content"><slot></slot></div>`;
      raiz.querySelector('[part="overlay"]').addEventListener('click', () => this.fechar());
      raiz.querySelector('[data-fechar]').addEventListener('click', () => this.fechar());
      this.addEventListener('click', (e) => { if (e.target.closest('[data-sy-fechar]')) this.fechar(); });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.fechar(); });
    }
    get aberto() { return this.hasAttribute('open'); }
    abrir(origem) {
      this.origem = origem || document.activeElement;
      this.setAttribute('open', '');
      document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      travarRolagem(true);
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '-1');
      requestAnimationFrame(() => this.focus({ preventScroll: true }));
    }
    fechar() {
      if (!this.aberto) return;
      this.removeAttribute('open');
      document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      travarRolagem(false);
      if (this.origem && this.origem.focus) this.origem.focus({ preventScroll: true });
    }
  }

  const BASE = `*,*::before,*::after{box-sizing:border-box}
    :host{position:fixed;z-index:999;visibility:hidden;transition:visibility 0s linear .45s}
    :host([open]){visibility:visible;transition-delay:0s}
    [part="overlay"]{position:fixed;inset:0;background:rgb(0 0 0 / .3);opacity:0;transition:opacity .45s}
    :host([open]) [part="overlay"]{opacity:1}
    [part="content"]{position:relative;background:#fff;border-radius:12px;transition:transform .45s cubic-bezier(.75,0,.175,1)}
    [part="outside-close-button"]{display:none}`;

  class NavigationDrawer extends SyDrawer {
    static estilo = BASE + `:host{inset:0;padding:8px}
      [part="content"]{display:flex;flex-direction:column;gap:24px;height:100%;max-width:400px;padding-top:24px;overflow:hidden;
        transform:translateX(calc(-100% - 16px))}
      :host([open]) [part="content"]{transform:none}`;
  }

  class QuickBuyDrawer extends SyDrawer {
    static estilo = BASE + `:host{inset:auto 0 0 auto;padding:16px}
      [part="content"]{padding:24px;max-height:calc(100vh - 32px);overflow:auto;transform:translateY(calc(100% + 16px))}
      :host([open]) [part="content"]{transform:none}
      @media (max-width:699px){:host{padding:8px}
        [part="content"]{max-height:calc(100vh - 80px)}
        [part="outside-close-button"]{display:grid;place-items:center;position:absolute;left:50%;top:-44px;translate:-50% 0;
          width:32px;height:32px;border-radius:9999px;border:0;background:#fff;color:rgb(4 33 70);cursor:pointer}
        :host([open]) [part="outside-close-button"]{top:auto;bottom:calc(100% + 12px)}}`;
  }

  class SearchDrawer extends SyDrawer {
    static estilo = BASE + `:host{inset:0 0 0 auto;width:680px;padding:16px}
      [part="content"]{height:100%;padding:32px 40px;overflow-y:auto;transform:translateX(calc(100% + 16px))}
      :host([open]) [part="content"]{transform:none}
      @media (max-width:699px){:host{inset:0;width:100%;padding:8px}
        [part="content"]{height:auto;max-height:calc(100vh - 16px);padding:20px 24px;transform:translateY(calc(-100% - 16px))}}`;
    abrir(origem) { super.abrir(origem); setTimeout(() => this.querySelector('[data-sy-busca]')?.focus(), 350); }
  }
  if (!customElements.get('navigation-drawer')) customElements.define('navigation-drawer', NavigationDrawer);
  if (!customElements.get('search-drawer')) customElements.define('search-drawer', SearchDrawer);
  if (!customElements.get('quick-buy-drawer')) customElements.define('quick-buy-drawer', QuickBuyDrawer);

  document.addEventListener('click', (e) => {
    const botao = e.target.closest('[aria-controls]');
    if (!botao) return;
    const alvo = document.getElementById(botao.getAttribute('aria-controls'));
    if (alvo instanceof SyDrawer) {
      e.preventDefault();
      alvo.aberto ? alvo.fechar() : alvo.abrir(botao);
    }
  });

  /* ---------------------------------------------------------------- busca instantânea */
  document.querySelectorAll('[data-sy-busca]').forEach((campo) => {
    const form = campo.closest('form');
    const alvo = form.querySelector('[data-sy-resultados]');
    const limpar = form.querySelector('.sy-search__reset');
    let espera, controle;
    const buscar = async () => {
      const q = campo.value.trim();
      limpar.classList.toggle('is-vazio', !campo.value);
      if (controle) controle.abort();
      if (!q) { alvo.replaceChildren(); return; }
      controle = new AbortController();
      try {
        const raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        const url = `${raiz}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=10&resources[options][unavailable_products]=last&section_id=sy-predictive-search`;
        const html = await (await fetch(url, { signal: controle.signal })).text();
        const ps = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sy-ps]');
        alvo.replaceChildren(...(ps ? [document.importNode(ps, true)] : []));
        let recuo = 0;
        alvo.querySelectorAll('.sy-ps__tab-item').forEach((item) => { item.style.marginInlineStart = recuo ? `${recuo}px` : ''; recuo += item.offsetWidth + 20; });
      } catch (erro) { if (erro.name !== 'AbortError') alvo.replaceChildren(); }
    };
    campo.addEventListener('input', () => { clearTimeout(espera); espera = setTimeout(buscar, 250); });
    form.addEventListener('reset', () => setTimeout(buscar, 0));
    alvo.addEventListener('click', (e) => {
      const aba = e.target.closest('[data-sy-tab]');
      if (!aba) return;
      alvo.querySelectorAll('[data-sy-tab]').forEach((b) => b.setAttribute('aria-selected', String(b === aba)));
      alvo.querySelectorAll('[data-sy-panel]').forEach((p) => (p.hidden = p.dataset.syPanel !== aba.dataset.syTab));
    });
  });

  /* ---------------------------------------------------------------- país (lista que abre sob o botão) */
  const fecharPaises = (exceto) => {
    document.querySelectorAll('.sy-loc__button[aria-expanded="true"]').forEach((b) => {
      if (b === exceto) return;
      b.setAttribute('aria-expanded', 'false');
      const pop = document.getElementById(b.getAttribute('aria-controls'));
      if (pop) pop.hidden = true;
    });
  };
  document.addEventListener('click', (e) => {
    const botao = e.target.closest('.sy-loc__button');
    if (botao) {
      const pop = document.getElementById(botao.getAttribute('aria-controls'));
      const abrir = botao.getAttribute('aria-expanded') !== 'true';
      fecharPaises(botao);
      botao.setAttribute('aria-expanded', String(abrir));
      if (pop) pop.hidden = !abrir;
      return;
    }
    if (!e.target.closest('.sy-loc__pop')) fecharPaises();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') fecharPaises(); });

  /* ---------------------------------------------------------------- carrossel de produtos */
  document.querySelectorAll('[data-sy-carousel]').forEach((trilho) => {
    const anterior = document.querySelector(`[data-sy-prev="${trilho.id}"]`);
    const proximo = document.querySelector(`[data-sy-next="${trilho.id}"]`);
    const barra = document.querySelector(`[data-sy-progress="${trilho.id}"]`);
    const passo = () => {
      const cartoes = trilho.querySelectorAll('product-card');
      if (cartoes.length < 2) return trilho.clientWidth;
      return cartoes[1].getBoundingClientRect().left - cartoes[0].getBoundingClientRect().left;
    };
    const atualizar = () => {
      const max = trilho.scrollWidth - trilho.clientWidth;
      if (anterior) anterior.disabled = trilho.scrollLeft <= 2;
      if (proximo) proximo.disabled = trilho.scrollLeft >= max - 2;
      if (barra) {
        barra.style.setProperty('--sy-s', String(Math.min(1, trilho.clientWidth / trilho.scrollWidth)));
        barra.style.setProperty('--sy-p', String(max > 0 ? trilho.scrollLeft / max : 0));
      }
    };
    anterior && anterior.addEventListener('click', () => trilho.scrollBy({ left: -passo(), behavior: 'smooth' }));
    proximo && proximo.addEventListener('click', () => trilho.scrollBy({ left: passo(), behavior: 'smooth' }));
    trilho.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', atualizar);
    atualizar();
  });

  /* ---------------------------------------------------------------- bolinhas de página (faixa de ícones) */
  document.querySelectorAll('[data-sy-dots]').forEach((pontos) => {
    const trilho = document.getElementById(pontos.dataset.syDots);
    if (!trilho) return;
    const botoes = [...pontos.querySelectorAll('button')];
    const marcar = () => {
      const i = Math.round(trilho.scrollLeft / Math.max(1, trilho.clientWidth));
      botoes.forEach((b, k) => b.setAttribute('aria-current', String(k === i)));
    };
    botoes.forEach((b, k) => b.addEventListener('click', () => trilho.scrollTo({ left: k * trilho.clientWidth, behavior: 'smooth' })));
    trilho.addEventListener('scroll', marcar, { passive: true });
  });

  /* ---------------------------------------------------------------- bolinhas de cor do cartão */
  document.addEventListener('change', (e) => {
    const radio = e.target;
    if (!radio.matches('.sy-swatches input[type="radio"]')) return;
    const cartao = radio.closest('product-card');
    const img = cartao && cartao.querySelector('[data-sy-card-img]');
    if (img && radio.dataset.img) { img.removeAttribute('srcset'); img.src = radio.dataset.img; }
    if (cartao && radio.dataset.url) cartao.querySelectorAll('[data-sy-card-link]').forEach((a) => (a.href = radio.dataset.url));
  });

  /* ---------------------------------------------------------------- carrinho: adicionar e abrir a gaveta */
  const adicionar = async (id, botao, quantidade = 1) => {
    const gaveta = document.querySelector('cart-drawer');
    botao && botao.classList.add('is-loading');
    try {
      const corpo = { items: [{ id: Number(id), quantity: Math.max(1, Number(quantidade) || 1) }] };
      if (gaveta) { corpo.sections = ['cart-drawer', 'cart-icon-bubble']; corpo.sections_url = window.location.pathname; }
      const r = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corpo),
      });
      const dados = await r.json();
      if (!r.ok || dados.status) throw new Error(dados.description || dados.message || 'erro');
      document.querySelectorAll('quick-buy-drawer[open]').forEach((d) => d.fechar());
      if (gaveta && typeof gaveta.renderContents === 'function' && dados.sections) {
        dados.id = dados.items && dados.items[0] ? dados.items[0].id : id;
        gaveta.classList.remove('is-empty');
        gaveta.renderContents(dados);
      } else {
        window.location.href = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart`;
      }
    } catch (erro) {
      alert(erro.message);
    } finally {
      botao && botao.classList.remove('is-loading');
    }
  };

  /* ---------------------------------------------------------------- depoimentos em abas */
  // a aba traz para a frente o cartão de mesma chave (os outros voltam à ordem de origem);
  // no celular os cartões passam um a um com o dedo
  const ligarAvis = (raiz) => {
    if (raiz.dataset.syLigado) return;
    raiz.dataset.syLigado = '1';
    {
      const abas = [...raiz.querySelectorAll('.sy-avis__tab')];
      const cartoes = [...raiz.querySelectorAll('.sy-avis__card')];
      const escolher = (aba) => {
        abas.forEach((a) => a.classList.toggle('active', a === aba));
        cartoes.forEach((c) => { c.style.display = 'flex'; c.style.order = c.dataset.block === aba.dataset.name ? '-1' : '1'; });
      };
      abas.forEach((aba) => {
        aba.addEventListener('click', () => escolher(aba));
        aba.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); escolher(aba); } });
      });
      if (window.innerWidth >= 786) return;
      const janela = raiz.querySelector('.sy-avis__wrapper');
      const trilho = raiz.querySelector('.sy-avis__track');
      let atual = 0; let inicio = null;
      const posicionar = () => { trilho.style.transform = `translateX(-${atual * janela.offsetWidth}px)`; };
      janela.addEventListener('touchstart', (e) => { inicio = e.touches[0].pageX; }, { passive: true });
      janela.addEventListener('touchend', (e) => {
        if (inicio === null) return;
        const distancia = inicio - e.changedTouches[0].pageX;
        inicio = null;
        if (distancia > 50 && atual < cartoes.length - 1) atual += 1;
        else if (distancia < -50 && atual > 0) atual -= 1;
        posicionar();
      });
      window.addEventListener('resize', posicionar);
      posicionar();
    }
  };
  const iniciarAvis = () => document.querySelectorAll('[data-sy-avis]').forEach(ligarAvis);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarAvis); else iniciarAvis();

  // Drawer: a base das gavetas, usada pela gaveta do carrinho (sy-carrinho.js)
  window.SY = Object.assign(window.SY || {}, { adicionar, Drawer: SyDrawer });

  // oferta por quantidade (ewc-bundle): o widget põe as unidades no carrinho e avisa; aqui a gaveta
  // do tema é redesenhada com o carrinho novo e aberta, como no "Ajouter au panier" comum
  document.addEventListener('ewc:cart:added', async (e) => {
    const raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    const gaveta = document.querySelector('cart-drawer');
    try {
      if (!gaveta || typeof gaveta.renderContents !== 'function') throw new Error('sem gaveta');
      const r = await fetch(`${raiz}?sections=cart-drawer,cart-icon-bubble`);
      const sections = await r.json();
      const itens = (e.detail && e.detail.items) || [];
      gaveta.classList.remove('is-empty');
      gaveta.renderContents({ id: itens[0] ? itens[0].id : 0, sections });
    } catch (erro) {
      window.location.href = `${raiz}cart`;
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-sy-quick-add]');
    if (!form) return;
    e.preventDefault();
    adicionar(form.querySelector('[name="id"]').value, e.submitter || form.querySelector('[type="submit"]'));
  });

  /* ---------------------------------------------------------------- compra rápida */
  let gavetaQb = null;
  const pegarGavetaQb = () => {
    if (!gavetaQb) {
      gavetaQb = document.createElement('quick-buy-drawer');
      gavetaQb.id = 'sy-quick-buy';
      gavetaQb.className = 'sy sy-qb-drawer';
      gavetaQb.setAttribute('role', 'dialog');
      gavetaQb.setAttribute('aria-modal', 'true');
      gavetaQb.setAttribute('aria-label', '+ Ajouter');
      document.body.appendChild(gavetaQb);
    }
    return gavetaQb;
  };

  const ligarVariantes = (qb) => {
    const fonte = qb.querySelector('[data-sy-qb-variants]');
    if (!fonte) return;
    const variantes = JSON.parse(fonte.textContent);
    if (qb.dataset.syLigado) { qb.removeEventListener('change', qb._syAtualizar); }
    qb.dataset.syLigado = '1';
    const opcoes = [...qb.querySelectorAll('fieldset.sy-vp__option')];
    const atualizar = () => {
      const escolhidas = opcoes.map((f) => {
        const r = f.querySelector('input:checked');
        const rotulo = f.querySelector('[data-sy-qb-escolha]');
        if (r && rotulo) rotulo.textContent = r.value;
        return r ? r.value : null;
      });
      const v = variantes.find((x) => x.options.every((o, i) => o === escolhidas[i]));
      const botao = qb.querySelector('[data-sy-qb-botao]');
      if (!v) { botao.disabled = true; botao.firstElementChild.textContent = 'Indisponible'; return; }
      qb.querySelector('[data-sy-qb-id]').value = v.id;
      botao.disabled = !v.available;
      botao.firstElementChild.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      const img = qb.querySelector('[data-sy-qb-img]');
      if (img && v.img) { img.removeAttribute('srcset'); img.src = v.img; }
      const preco = qb.querySelector('[data-sy-qb-price]');
      preco.innerHTML = `<sale-price class="${v.compare ? 'sy-on-sale' : 'sy-subdued'}"><span class="sy-sr">Prix de vente</span>${v.price}</sale-price>`
        + (v.compare ? ` <compare-at-price class="sy-subdued sy-line-through"><span class="sy-sr">Prix normal</span>${v.compare}</compare-at-price>` : '');
    };
    qb._syAtualizar = atualizar;
    qb.addEventListener('change', atualizar);
  };

  document.addEventListener('click', async (e) => {
    const botao = e.target.closest('[data-sy-quick-buy]');
    if (!botao) return;
    e.preventDefault();
    const gaveta = pegarGavetaQb();
    botao.classList.add('is-loading');
    try {
      const raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      const r = await fetch(`${raiz}products/${botao.dataset.syQuickBuy}?variant=${botao.dataset.variant}&section_id=sy-quick-buy`);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const qb = doc.querySelector('[data-sy-qb]');
      if (!qb) throw new Error('produto indisponível');
      gaveta.replaceChildren(...[...document.importNode(qb, true).childNodes]);
      ligarVariantes(gaveta);
      gaveta.abrir(botao);
    } catch (erro) {
      // sem a compra rápida, a página do produto (cartão da vitrine ou linha de complemento)
      const link = botao.closest('product-card, .sy-hp')?.querySelector('a[href]');
      window.location.href = link ? link.href : `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}products/${botao.dataset.syQuickBuy}`;
    } finally {
      botao.classList.remove('is-loading');
    }
  });
})();
